import React from "react";
import { Button, Typography, Card, Col, Row, Divider, Segmented } from "antd";
import MenuCard from "../../components/Card";
import MenuImg from "../../assets/images/menu.png";
import Menus from "../Menus";

const { Title } = Typography;

const Menu = (props) => {
  return (
    <>
      {/* <div className="dashboard">
        <div className="catering-header">
          <Title level={4}>Catering / Menu</Title>
          <Button type="primary" onClick={() => {}}>
            Add New Menu
          </Button>
        </div>
        <MenuCard data={{image:MenuImg}} />
      </div> */}
      <Menus {...props} isCatering/>
    </>
  );
};
export default Menu;
